import React from 'react';
import Leaderboard from '../components/Leaderboard';

const LeaderboardPage = () => (
  <div className="min-h-screen py-8 px-4">
    <Leaderboard />
  </div>
);

export default LeaderboardPage;
